"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IkeJson = void 0;
const tslib_1 = require("tslib");
// @todo use lodash
const fast_deep_equal_1 = tslib_1.__importDefault(require("fast-deep-equal"));
exports.IkeJson = {
    /**
     * Attempt to parse a string as JSON
     * Catching the parse exception
     *
     * @returns Resulting JSON, or null if failed to parse
     */
    parse(s) {
        if (s == null) {
            return null;
        }
        try {
            return JSON.parse(s);
        }
        catch (_e) {
            return null;
        }
    },
    deepEqual(objA, objB) {
        return (0, fast_deep_equal_1.default)(objA, objB);
    },
};
//# sourceMappingURL=json.js.map